import { useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { addSupplier } from "services/createServices";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

export default function AddSupplier() {
  const { register, handleSubmit, errors } = useForm();
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const { addToast } = useToasts();
  const locationData = location.state;

  const onSubmit = async (data) => {
    data.c_sel = "0";
    data.termz = "0";
    data.category = "0";
    data.del = "0";

    if (locationData) {
      try {
        setLoading(true);
        addToast("Successfully updated Supplier", {
          appearance: "success",
          autoDismiss: true,
        });
        setLoading(false);
        history.push("/admin/file-maintainance/suppliers");
      } catch (error) {
        setLoading(false);
        addToast(
          error.response.data
            ? error.response.data.message
            : "Internal Serval Error",
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
      }
    } else {
      try {
        setLoading(true);
        await addSupplier(data);
        console.log(data);
        addToast("Successfully created new supplier", {
          appearance: "success",
          autoDismiss: true,
        });
        setLoading(false);
        history.push("/admin/file-maintainance/suppliers");
      } catch (error) {
        setLoading(false);
        addToast(
          error.response.data
            ? error.response.data.message
            : "Internal Serval Error",
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
      }
    }
  };

  return (
    <>
      <div
        className=" break-words border-0"
        style={{ minHeight: "520px", paddingTop: "4rem" }}
      >
        <div
          className="flex flex-col shadow-lg rounded-lg "
          style={{ margin: "3rem" }}
        >
          <div
            className="rounded-t bg-white mb-0 px-6 py-6"
            style={{ background: "#9CA3AF" }}
          >
            <div>
              <h6 className="text-gray-800 text-xl font-bold">
                Add New Supplier
              </h6>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "1rem",
                }}
              >
                <Link
                  to="/admin/dashboard"
                  className="text-white text-sm hover:text-gray-200 lg:inline-block font-semibold"
                >
                  DASHBOARD
                </Link>
                <ArrowForwardIosIcon
                  style={{ color: "white", fontSize: "12px", margin: "0 1rem" }}
                />
                <Link
                  to="/admin/file-maintainance"
                  className="text-white text-sm hover:text-gray-200 lg:inline-block font-semibold"
                >
                  FILE MAINTAINANCE
                </Link>
                <ArrowForwardIosIcon
                  style={{ color: "white", fontSize: "12px", margin: "0 1rem" }}
                />
                <Link
                  to="/admin/file-maintainance/suppliers"
                  className="text-white text-sm hover:text-gray-200 lg:inline-block font-semibold"
                >
                  SUPPLIERS
                </Link>
                <ArrowForwardIosIcon
                  style={{ color: "white", fontSize: "12px", margin: "0 1rem" }}
                />
                <span
                  className="text-sm uppercase hidden lg:inline-block font-semibold"
                  style={{ color: "rgb(194 216 234)" }}
                >
                  ADD SUPPLIER
                </span>
              </div>
            </div>
          </div>
          <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
            <form>
              <h6 className="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
                Supplier Details
              </h6>
              <div className="flex flex-wrap">
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="code"
                    >
                      Supplier Code
                    </label>
                    <input
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      name="code"
                      placeholder="code"
                      ref={register({ required: true })}
                    />
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.code && "Supplier Code is required"}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="name"
                    >
                      Supplier Name
                    </label>
                    <input
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="name"
                      name="name"
                      ref={register({ required: true })}
                    />
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.name && "Supplier Name is required"}
                    </span>
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="contact"
                    >
                      Contact
                    </label>
                    <input
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="contact"
                      name="contact"
                      ref={register({ required: false })}
                    />
                  </div>
                </div>
                <div className="w-full lg:w-6/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="phone"
                    >
                      Phone
                    </label>
                    <input
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="phone"
                      name="phone"
                      ref={register({ required: true })}
                    />
                    <span style={{ color: "red", fontSize: "12px" }}>
                      {errors.phone && "Supplier Phone No. is required"}
                    </span>
                  </div>
                </div>
              </div>
              <hr className="mt-6 border-b-1 border-gray-400" />

              <h6 className="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">
                Description
              </h6>
              <div className="flex flex-wrap">
                <div className="w-full lg:w-4/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="address"
                    >
                      Address
                    </label>
                    <input
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="address"
                      name="address"
                      ref={register({ required: false })}
                    />
                  </div>
                </div>
                <div className="w-full lg:w-4/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="town"
                    >
                      Town
                    </label>
                    <input
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="town"
                      name="town"
                      ref={register({ required: false })}
                    />
                  </div>
                </div>
                <div className="w-full lg:w-4/12 px-4">
                  <div className="relative w-full mb-3">
                    <label
                      className="block uppercase text-gray-700 text-xs font-bold mb-2"
                      htmlFor="mail"
                    >
                      Mail
                    </label>
                    <input
                      type="text"
                      className="px-3 py-3 placeholder-gray-400 text-gray-700 bg-white rounded text-sm shadow focus:outline-none focus:shadow-outline w-full ease-linear transition-all duration-150"
                      placeholder="mail"
                      name="mail"
                      ref={register({ required: false })}
                    />
                  </div>
                </div>
                <div className="text-center flex justify-between">
                  <button
                    className="bg-blue-500 text-white active:bg-blue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                    type="button"
                    style={{
                      marginTop: "2rem",
                    }}
                    onClick={handleSubmit(onSubmit)}
                  >
                    Add Supplier
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
